<template>
  <!--      归档对话框-->
  <Dialog
      v-model="dialogVisible"
      :title="$t('common.archives.return')"
      :dialogVisible="dialogVisible"
      :isHeadLine="false"
      style="min-width: 800px"
      @update:dialogVisible="close"
      :width="1020"
      :top="forms.merge===$t('common.email.newContacts')?'4vh':'8vh'"
      :close-on-click-modal="false"
  >
    <template #content>
      <!--    {{customerListAll}}-->
      <el-scrollbar style="overflow-x: hidden !important;"
                    :height="forms.merge===$t('common.email.newContacts')|| forms.customerName===9999?'53vh':'250'">
        <div class="my_forms" style="overflow: hidden !important;">
          <div>
            <div class="box_titles">{{ $t("common.email.selectDocumentEmail") }}</div>
            <div class="inner_card sp_box">
              <el-form-item class="sp_email" :label="$t('common.emailbox')+':'" label-width="72px" prop="email"
                            label-position="right">
                <el-input size="small" v-if="options.length===0"
                          v-model="forms.email"
                          style="color: #a9abb1"
                          :placeholder="$t('20202')"
                />
                <el-select
                    size="small"
                    v-else
                    v-model="forms.email"
                    placeholder="Select"
                    label-position="left"
                    style="width: 240px"
                >
                  <el-option
                      v-for="item in options"
                      :key="item.email"
                      :label="item.email"
                      :value="item.email"
                  />
                </el-select>
                <!--                  {{ $t("system.copy") }}-->
                <el-icon @click="copyEmail()" style="margin-left: 12px">
                  <CopyDocument/>
                </el-icon>
              </el-form-item>
            </div>
          </div>
          <div>
            <div class="box_titles">{{ $t("common.email.chooseToArchiveCustomer") }}</div>
            <div class="inner_card sp_box">
              <el-form-item class="el-row" :label="$t('common.customer.name')+':'" label-position="left"
                            prop="customerName">
                <CustomerSelect
                    v-model="forms.customerName"
                    :teamId="teamId"
                    class="demo"
                    ref="customerSelectRef"
                    @change="handleSelectChange"
                    :placeholder="customerFlag?$t('select.new.customer'):$t('select.customer.name')"
                    newCusomerFlag
                />
              </el-form-item>
              <el-form-item v-if="forms.customerName!==9999" class="el-row" :label="$t('common.email.archiveWay')+':'"
                            prop="customerName" label-position="left">
                <el-select size="small" v-model="forms.merge" class="m-2" placeholder="Select"
                           @change="handleChangesMerge"
                           :disabled=" forms.customerName === ''">
                  <el-option :label="$t('common.email.newContacts')"
                             :value="$t('common.email.newContacts')"></el-option>
                  <el-option :label="$t('common.cds6')" :value="$t('common.cds6')"></el-option>
                  <el-option
                      v-for="item in contactList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                  />
                </el-select>
              </el-form-item>
            </div>
          </div>
          <div v-if="forms.customerName===9999">
            <div class="box_titles">{{ $t('create.gui.customer') }}</div>
            <Forms :isShowButton="false" ref="childRef" :isShowTitleSp="false">
              <template #createMessage>
                <div style="display: flex;align-items: center;">
                  <div class="gutter_my">
                    <el-form-item :label="$t('common.region.name')" prop="zoneAddress">
                      <el-select size="small" v-model="ruleForm.zoneAddress" :placeholder="$t('common.please.select')"
                                 filterable
                                 value-key="country"
                                 @change="selectMore($event)"
                      >
                        <el-option
                            v-for="item in areaList"
                            :label="lang!=='zh-CN'?item.countryEn:item.country"
                            :value="item"
                            :key="item.country"
                        />
                      </el-select>
                    </el-form-item>
                  </div>
                  <div class="gutter_my">
                    <el-form-item
                        prop="customerCode">
                      <template #label>
                        <span><span style="color: #e47470;margin-right: 4px">*</span>{{ $t('common.customer.number') }}</span>
                      </template>
                      <el-input size="small" v-model="ruleForm.customerCode"
                                :placeholder="ruleForm.customerCodeDefault"/>
                    </el-form-item>
                  </div>
                  <div class="gutter_my">
                    <el-form-item
                        :label="$t('common_customer_name')"
                        prop="customerName">
                      <el-input size="small" v-model="ruleForm.customerName" :placeholder="$t('common.please.input')"/>
                    </el-form-item>
                  </div>
                  <div class="gutter_my">
                    <el-form-item
                        :label="$t('common.customer.source')"
                        prop="customerOrigin"
                    >
                      <!--                      <el-input-->
                      <!--                          size="small"-->
                      <!--                          v-model="ruleForm.customerOrigin"-->
                      <!--                          :placeholder="$t('common.please.input')"-->
                      <!--                      />-->
                      <SelectEditTag v-model:selectedMember="ruleForm.customerOriginList" ref="selectTag"
                                     :typeSelect="1"></SelectEditTag>
                    </el-form-item>
                  </div>
                  <div class="gutter_my" style="position: relative;z-index: -9999">
                    <el-form-item :label="$t('common.bybranch')">
                      <el-input
                          size="small"
                          v-model="ruleForm.mangerVOList[0].managerName"
                          :placeholder="$t('common.please.input')"
                          disabled
                      />
                    </el-form-item>
                  </div>
                </div>
              </template>
            </Forms>
            <!--            新建联系人勾选-->
            <el-checkbox v-model="isSelectCreateContact"
                         style="padding-left:10px;font-size: 14px !important;font-weight: 500;margin-top: 5px;height: 20px"
                         :label="$t('common.email.newContacts')" size="large"
                         @change="selectCreateContact">
            </el-checkbox>
          </div>
          <div v-if="forms.merge===$t('common.email.newContacts') || isSelectCreateContact&&forms.customerName===9999"
               class="box_titles_created" style="margin-top: 20px;">
            <!--            <div class="inner_card">-->
            <el-form
                ref="ruleFormRef"
                :model="ruleFormUsers"
                :rules="rules"
                label-width="50px"
                class="demo-ruleForm-ssssss"
                style="padding-right: 10px !important;"
            >
              <div class="tops">
                <div class="inner_text">{{ $t('contact.info') }}</div>
              </div>
              <el-checkbox
                  style="margin-left: 12px;font-size: 13px !important;"
                  :label="$t('common.mainContact')"
                  v-model="ruleFormUsers.isMain"/>
              <div style="display: flex;width: 100%;align-items: center;margin-top: 12px;">
                <div class="contact_my">
                  <el-form-item
                      :label="$t('common.name')"
                      prop="name"
                      :rules="[{required: true, message: $t('form.contact.name.reg'), trigger: ['change','blur']}]"
                  >
                    <el-input
                        size="small"
                        v-model="ruleFormUsers.name"
                        :placeholder="$t('90201')"
                    />
                  </el-form-item>
                </div>
                <div class="contact_my">
                  <el-form-item
                      :label="$t('common.user.nick1')"
                      prop="nickName"
                  >
                    <el-input
                        size="small"
                        v-model="ruleFormUsers.nickName"
                        :placeholder="$t('common.please.input')"
                    />
                  </el-form-item>
                </div>
                <div class="contact_my">
                  <el-form-item :label="$t('common.sex')" prop="sex">
                    <!--                                <el-radio-group-->
                    <!--                                    size="small"-->
                    <!--                                    v-model="ruleFormUsers.sex"-->
                    <!--                                    class="ml-4"-->
                    <!--                                >-->
                    <!--                                  <el-radio :label="1" :value="1">{{-->
                    <!--                                      $t("common.man")-->
                    <!--                                    }}-->
                    <!--                                  </el-radio>-->
                    <!--                                  <el-radio :label="2" :value="2">{{-->
                    <!--                                      $t("common.woman")-->
                    <!--                                    }}-->
                    <!--                                  </el-radio>-->
                    <!--                                </el-radio-group>-->
                    <el-select
                        v-model="ruleFormUsers.sex"
                        size="small"
                        class="ml-4"
                        :placeholder="$t('common.please.select')"
                        style="width: 120px"
                    >
                      <el-option :label="$t('common.man')" :value="1"/>
                      <el-option :label="$t('common.woman')" :value="2"/>
                    </el-select>
                  </el-form-item>
                </div>
                <div class="contact_my">
                  <el-form-item
                      :label="$t('common.dateofbirth')"
                      prop="birthday"
                  >
                    <el-date-picker
                        size="small"
                        v-model="ruleFormUsers.birthday"
                        type="date"
                        :placeholder="$t('common.please.select')"
                    />
                  </el-form-item>
                </div>
              </div>
              <div style="width: 100%;display: flex;align-items: center">
                <div class="contact_my">
                  <el-form-item
                      :label="$t('common.department')"
                      prop="phone"
                  >
                    <el-input
                        size="small"
                        v-model="ruleFormUsers.departName"
                        :placeholder="$t('common.please.input')"
                    />
                  </el-form-item>
                </div>
                <div class="contact_my">
                  <el-form-item
                      :label="$t('common.company.position')"
                      prop="post"
                  >
                    <el-input
                        size="small"
                        v-model="ruleFormUsers.post"
                        :placeholder="$t('sys.tip.input.position')"
                    />
                  </el-form-item>
                </div>
                <div class="contact_my">
                  <el-form-item
                      :label="$t('common.remark')"
                      prop="remark"
                  >
                    <el-input
                        size="small"
                        v-model="ruleFormUsers.remark"
                        :placeholder="$t('sys.tip.input.remark')"
                        @click="remarkDesSalVisible = true"
                    />
                    <el-dialog v-model="remarkDesSalVisible" :title="$t('common.remark')">
                      <template #default>
                        <el-input
                            style="white-space: pre-wrap;word-break: break-all"
                            v-model="ruleFormUsers.remark"
                            type="textarea"
                            :rows="5"
                            size="small"
                            :placeholder="$t('common.please.input')"
                        />
                      </template>
                      <template #footer style="border-top: 1px solid">
                        <div class="dialog-footer">
                          <el-button size="small" @click="remarkDesSalVisible = false"
                                     style="margin-right: 20px"
                          >{{ $t('common.sss16') }}
                          </el-button
                          >
                          <el-button
                              size="small"
                              type="primary"
                              @click="remarkDesSalVisible = false"
                          >{{ $t('common.save') }}
                          </el-button
                          >
                        </div>
                      </template>
                    </el-dialog>
                  </el-form-item>
                </div>
              </div>
              <el-row :gutter="24" style="margin-top: -12px">
                <el-col :span="12" style="padding-right: 10px !important;">
                  <MyTitles :title="$t('common.emailbox')">
                    <template #content>
                      <div class="bottoms asterisk-left">
                        <el-form-item
                            :label="index===0?$t('common.emailbox'):' '"
                            class="sp_form_item vertical-form-item"
                            style="margin-top: 20px;padding-bottom: 0px"
                            v-for="(
                                          item, index
                                        ) in ruleFormUsers.mailContactEmailList"
                            :style="{marginTop:index===0? '18px !important':'8px !important'}"
                            :key="index"
                            :prop="
                                            'mailContactEmailList[' +
                                            index +
                                            '].content'
                                          "
                            :rules="[
                                          {
                                            pattern:
                                            emailReg,
                                            message:$t('form.email.reg') ,
                                            trigger: ['change','blur'],
                                          },
                                        ]"
                        >
                          <div class="email-input">
                            <el-input
                                size="small"
                                v-model="item.content"
                                :placeholder="$t('90201')"
                            />
                            <el-button
                                link
                                class="danger_delete_btn_link"
                                size="small"
                                type="danger"
                                style="
                                                                       margin: 0px 5px !important;
                                                                        cursor: pointer;
                                                                      "
                                @click="removeEmail(index,item)"
                            >
                              {{ $t('common.delete') }}
                            </el-button>
                          </div>
                          <el-button
                              v-if="index===ruleFormUsers.mailContactEmailList.length-1"
                              size="small"
                              link
                              style="margin-top: 20px;"
                              @click="addEmail"
                              type="primary"
                          >
                            <template #icon>
                              <el-icon>
                                <Plus/>
                              </el-icon>
                            </template>
                            {{ $t('common.add') }}
                          </el-button>
                          <div v-else style="width: 93px !important;"></div>
                        </el-form-item>
                        <!--                                      <el-form-item-->
                        <!--                                          style="margin: 0px !important;justify-content: start !important;margin-top: 15px !important;">-->
                        <!--                                        <el-button-->
                        <!--                                            v-if="!ruleFormUsers.mailContactEmailList.length>0"-->
                        <!--                                            size="small"-->
                        <!--                                            @click="addEmail"-->
                        <!--                                            :icon="Plus"-->
                        <!--                                            type="primary"-->
                        <!--                                        >-->
                        <!--                                          {{ $t("common.add") }}-->
                        <!--                                        </el-button>-->
                        <!--                                      </el-form-item>-->
                      </div>
                    </template>
                  </MyTitles>
                </el-col>
                <el-col :span="12" style="padding-right: 10px !important;">
                  <MyTitles :title="$t('common.contact.phone')">
                    <template #content>
                      <div class="bottoms asterisk-left">
                        <el-form-item
                            :label-width="route.path.indexOf('success')!==-1?40:40"
                            :label="index===0?$t('common.contact.phone'):' '"
                            class="sp_form_item vertical-form-item"
                            style="margin-top: 20px;padding-bottom: 0px;"
                            v-for="(item, index) in ruleFormUsers.contactPhoneList"
                            :style="{marginTop:index===0?'18px !important':'8px !important'}"
                            :key="index"
                            :prop="'contactPhoneList['+index +'].content'"
                        >
                          <div class="email-input">
                            <el-input
                                size="small"
                                v-model="item.content"
                                :placeholder="$t('common.please.input')"
                            />
                            <el-button
                                link
                                class="danger_delete_btn_link"
                                size="small"
                                type="danger"
                                style="
                                              margin: 0px 5px !important;
                                              cursor: pointer;
                                              "
                                @click="removePhone(index,item)"
                            >
                              {{ $t('common.delete') }}
                            </el-button>
                          </div>
                          <el-button
                              style="margin-top: 20px;"
                              v-if="index===ruleFormUsers.contactPhoneList.length-1"
                              size="small"
                              @click="addPhone"
                              type="primary"
                              link
                          >
                            <template #icon>
                              <el-icon>
                                <Plus/>
                              </el-icon>
                            </template>
                            {{ $t('common.add') }}
                          </el-button>
                          <div v-else style="width: 93px !important;"></div>
                        </el-form-item>
                      </div>
                    </template>
                  </MyTitles>
                </el-col>
              </el-row>
              <el-row :gutter="24" style="margin-top: 20px">
                <el-col :span="12" style="padding-right: 10px !important;">
                  <MyTitles :title="$t('common.she.mei')">
                    <template #content>
                      <div class="bottoms asterisk-left">
                        <el-form-item
                            :label="index===0?$t('common.she.mei'):' '"
                            class="sp_form_item vertical-form-item"
                            style="margin-top: 20px;padding-bottom: 0px"
                            v-for="(item, index) in ruleFormUsers.contactWayList"
                            :style="{marginTop:index===0? '18px !important':'8px !important'}"
                            :key="index"
                            :prop="'contactWayList[' +index +'].content'"
                        >
                          <div class="email-input">
                            <el-input
                                size="small"
                                v-model="item.content"
                                :placeholder="$t('common.please.input')"
                            />
                            <el-button
                                link
                                class="danger_delete_btn_link"
                                size="small"
                                type="danger"
                                style="margin: 0px 5px !important;cursor: pointer;"
                                @click="removeText(index,item)"
                            >
                              {{ $t('common.delete') }}
                            </el-button>
                          </div>
                          <el-button
                              v-if="index===ruleFormUsers.contactWayList.length-1"
                              size="small"
                              @click="addText"
                              type="primary"
                              style="margin-top: 12px;"
                              link
                          >
                            <template #icon>
                              <el-icon>
                                <Plus/>
                              </el-icon>
                            </template>
                            {{ $t('common.add') }}
                          </el-button>
                          <div v-else style="width: 93px !important;"></div>
                        </el-form-item>
                      </div>
                    </template>
                  </MyTitles>
                </el-col>
                <el-col :span="12" style="padding-left: 10px !important;padding-right: 10px !important;">
                  <MyTitles :title="$t('common.memorialday')">
                    <template #content>
                      <div class="remembers asterisk-left">
                        <!-- <RememberDate></RememberDate> -->
                        <div style="width: 100% !important;">
                          <div
                              v-for="(event, index) in ruleFormUsers.mailContactSouvenirList"
                              :key="index"
                              style="margin-bottom: 3px !important;display: flex;flex-direction: column"
                          >
                            <div style="width: 100%;" class="event-input">
                                            <span
                                                :style="{width:'45px',fontSize:'13px',color:'#000',paddingLeft:route.path.indexOf('success')!==-1?'2px':'0px'}">
                                              {{
                                                index === 0 ? $t('common.memorialday') : ''
                                              }}
                                            </span>
                              <el-input
                                  size="small"
                                  v-model="event.remark"
                                  :placeholder="$t('common.contact.info.anniversary.name')"
                                  ref="inputRef"
                                  style="width: 50% !important;"
                              ></el-input>
                              <div style="margin: 0 10px"></div>
                              <el-date-picker
                                  size="small"
                                  v-model="event.souvenirDay"
                                  type="date"
                                  class="event-text"
                                  :placeholder="$t('common.please.select')"
                                  style="width: 40% !important;"
                              />
                              <div class="setting">
                                <el-button
                                    size="small"
                                    v-if="event.showButtons"
                                    @click="removeEvent(index)"
                                    link
                                    style="margin: 0px 5px !important;"
                                    type="danger"
                                >{{ $t("common.delete") }}
                                </el-button>
                                <el-button
                                    size="small"
                                    v-if="!event.showButtons"
                                    @click="removeEvent(index)"
                                    link
                                    style="margin: 0px 5px !important;"
                                    type="danger"
                                >{{ $t("common.delete") }}
                                </el-button>
                              </div>
                            </div>
                            <div style="margin-top: 10px;margin-left: 38px;">
                              <el-button v-if="index===ruleFormUsers.mailContactSouvenirList.length-1"
                                         size="small"
                                         @click="addEvent" type="primary"
                                         link
                              >
                                <template #icon>
                                  <el-icon>
                                    <Plus/>
                                  </el-icon>
                                </template>
                                {{ $t('common.add') }}
                              </el-button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </template>
                  </MyTitles>
                </el-col>
              </el-row>
            </el-form>
            <!--            </div>-->
          </div>
        </div>
      </el-scrollbar>
    </template>
    <template #footer>
      <div class="footer_box">
        <el-button size="small" @click.native.stop="close">{{ $t('common.sss16') }}</el-button>
        <el-button size="small" type="primary" @click.native.stop="saveAllDiaDatas">{{ $t('common.save') }}</el-button>
      </div>
    </template>
  </Dialog>
</template>

<script setup>
import Dialog from "@/components/Dialog.vue";
import {defineProps, ref, watch, defineEmits, reactive, computed, onMounted, defineExpose, toRaw, nextTick} from "vue";
import {useRoute, useRouter} from "vue-router";
import MyTitles from "@/views/Customer/Detail/MyTitles.vue";
import {
  addMailCustomerContact, checkMainContact,
  editMailCustomerContact,
  getMailCustomerContactByCustomerId,
  requestAllCustomer
} from "@/api/customer";
import {ElMessage} from "element-plus";
import {useStore} from "vuex";
import {i18n} from "@/lang";
import {emailReg} from '@/utils/statusParams'
import {Plus} from "@element-plus/icons-vue";
import dayjs from "dayjs";
import Forms from "@/views/Customer/CreateCheck/Forms.vue";
import CustomerSelect from '../../../components/CustomerSelect.vue';
import SelectEditTag from "@/components/SelectEditTag.vue";

const router = useRouter()
const route = useRoute()
const emit = defineEmits()
const store = useStore();
const customerSelectRef = ref()

const customerListAll = computed(() => store.state.customer.customerListAll)

// 建档信息
const ruleForm = computed(() => store.state.customer.ruleForm);
const form = computed(() => store.state.customer.form)
// 区域列表
const areaList = computed(() => store.state.customer.areaList);
const randomCustomerCode = computed(() => store.state.customer.randomCustomerCode)
const dialogVisibleTips = ref(false)
const contactList = ref([]) // 手动筛选联系人列表
// 归档
const dialogVisible = ref(false)
// 是否勾选 新建联系人
const isSelectCreateContact = ref(false);
// 选择勾选 改变状态
const selectCreateContact = async (val) => {
  if (val) {
    //   邮箱添加到 联系人
    await store.commit('customer/setForm', {
      phones: form.value.phones,
      emails: [{email: "", isDefault: true}],
    })
    if (ruleFormUsers.mailContactEmailList[0]) {
      formReset()
      ruleFormUsers.mailContactEmailList[0].content = forms.email
      ruleFormUsers.mailContactEmailList[0].isDefault = 1
    }
  } else {
    //   邮箱添加到 客户
    await store.commit('customer/setForm', {
      phones: form.value.phones,
      emails: [{email: forms.email, isDefault: true}],
    })
    if (ruleFormUsers.mailContactEmailList[0]) {
      formReset()
      ruleFormUsers.mailContactEmailList[0].content = ""
      ruleFormUsers.mailContactEmailList[0].isDefault = 0
    }
  }
  // console.log(val, selectComName.value, 'asdfasfasfdsaf')
  if (forms.customerName === 9999) {
    //   新增客户
    ruleFormUsers.isMain = true;
  } else {
    ruleFormUsers.isMain = false;
  }
}

// 表单重置
const formReset = () => {
  Object.assign(ruleFormUsers, {
    departName: "",
    name: "",
    sex: 1,
    post: "",
    telPhone: "",
    birthday: null,
    remark: "",
    nickName: "",
    isMain: false,
    contactWayList: [
      {
        content: "",
        isDefault: 0,
      }
    ],
    contactPhoneList: [
      {
        content: "",
        isDefault: 0,
      }
    ],
    mailContactEmailList: [
      {
        content: "",
        isDefault: 0,
      },
    ],
    mailContactSouvenirList: [
      {
        remark: "",
        souvenirDay: "",
        editing: true,
        showButtons: true,
      }
    ],
  })
}


// 对话框表单信息
const forms = reactive({email: '', customerName: '', merge: i18n.global.t('common.cds6'), contactName: ''})
const teamId = computed(() => store.state.email.teamID);
const customerFlag = computed(() => store.state.email.customerFlag)
// 表单数据
const ruleFormUsers = reactive({
  departName: "",
  name: "",
  sex: 1,
  post: "",
  telPhone: "",
  birthday: null,
  remark: "",
  nickName: "",
  isMain: false,
  contactWayList: [
    {
      content: "",
      isDefault: 1,
    }
  ],
  contactPhoneList: [
    {
      content: "",
      isDefault: 1,
    }
  ],
  mailContactEmailList: [
    {
      content: "",
      isDefault: 1,
    },
  ],
  mailContactSouvenirList: [
    {
      remark: "",
      souvenirDay: "",
      editing: true,
      showButtons: true,
    }
  ],
});

const options = ref([])
// 表单校验规则
const rules = reactive({
  name: [{required: true, message: i18n.global.t('sys.tip.input.name'), trigger: ["blur", 'change']}],
});
const remarkDesSalVisible = ref(false)


const {value, targetEmail, reGetList, targetEmailData} = defineProps({
  value: {type: Boolean, default: false},
  targetEmail: {
    type: Array,
    default: () => []
  },
  targetEmailData: {
    type: String,
    default: '',
  },
  reGetList: {
    type: Function,
  },
})

watch(() => value, (val) => {
  dialogVisibleTips.value = val;
}, {immediate: true})

const close = () => {
  emit("close")
}

async function defaultSelectCustomer() {
  if (route.path === '/email/has_send') {
    options.value = targetEmail;
  }

  if (targetEmail.length !== 0) {
    if (route.path.indexOf('success') !== -1) {
      // 成功页的归档
      forms.email = targetEmail.find(_ => _.email === targetEmailData)?.email
    } else {
      //普通归档
      forms.email = targetEmail[0].email
    }
  }
  // console.log(targetEmail, route.path, route.path.indexOf('success') !== -1, 'targetEmail', targetEmail[0].email, forms)
  // 默认选中第一个
  // const result = JSON.parse(JSON.stringify(optionsCustomers))
  // console.log('$$$', optionsCustomers.value)
  const optionsCustomers = customerListAll.value
  console.log(optionsCustomers, 'customerSelectRef.value.customerListAll')
  if (optionsCustomers.length > 1) {
    forms.customerName = optionsCustomers[1].id
    let res = await getMailCustomerContactByCustomerId({customerId: forms.customerName})
    if (res.code !== 200) {
      ElMessage.error(res.message)
      return
    }
    const targetNewObj = res.result
    // 寻找第一个的联系人
    if (targetNewObj.length !== 0) {
      contactList.value = targetNewObj
      forms.merge = targetNewObj.length > 2 ? targetNewObj[2].id : i18n.global.t('common.cds6')
    } else {
      contactList.value = []
      forms.merge = targetNewObj.length > 2 ? targetNewObj[2].id : i18n.global.t('common.cds6')
      ruleFormUsers.mailContactEmailList = [{content: forms.email, isDefault: 1}]
      forms.contactName = ''
    }
    localStorage.setItem('formsFlag', JSON.stringify(forms))
    store.commit('email/setCustomerFlag', false)
  } else {
    store.commit('email/setCustomerFlag', true)
  }
}

// 选中的公司名称
// const selectComName = ref('')

async function handleSelectChange(value) {
  if (value === 9999) {
    //   表单重制
    await store.commit('customer/setRuleForm', {
      zoneCode: "",
      customerCode: "",
      customerCodeDefault: i18n.global.t('90201'),
      zoneAddress: "",
      customerName: "",
      setUpTime: null,
      economicNature: "",
      companyWebsite: "",
      companyAddress: "",
      phoneWayList: [],
      emailWayList: [],
      companyFax: "",
      companyRemark: "",
      customerLevel: "",
      customerType: "",
      customerTypeId: "",
      product: "",
      marketingRemark: " ",
      createBy: "",
      branchAdmin: "",
      mangerVOList: [{managerName: ''}]
    })
    await store.commit('customer/setForm', {
      phones: [{phoneNumber: "", isDefault: true}],
      emails: [{email: forms.email, isDefault: true}],
    })
  }

  let res = await getMailCustomerContactByCustomerId({customerId: value})
  if (res.code !== 200) {
    ElMessage.error(res.message)
    return
  }
  const targetNewObj = res.result
  if (targetNewObj.length !== 0) {
    contactList.value = targetNewObj
    forms.merge = targetNewObj.length > 2 ? targetNewObj[2].id : i18n.global.t('common.cds6')
  } else {
    contactList.value = [];
    forms.merge = targetNewObj.length > 2 ? targetNewObj[2].id : i18n.global.t('common.cds6');
  }
  localStorage.setItem('formsFlag', JSON.stringify(forms))
}


// 获取所有的客户 ！！所有客户
function getAllCustomers() {
  nextTick(async () => {
    await customerSelectRef.value.getAllCustomer()
    console.log(customerSelectRef.value, 'customerListAll')
    await defaultSelectCustomer();
  })
}


// 建档
function createdNewCustomer() {
  emit('createCustomer', forms.email)
}

const exitMainContactFlag = ref(false)

async function handleChangesMerge(value) {
  // console.log(value, 'fff')
  forms.merge = value;
  ruleFormUsers.mailContactEmailList = [{content: forms.email, isDefault: 1}]
  if (value === i18n.global.t('common.email.newContacts')) {
    //   联系人是否是主联系人
    try {
      const payload = {
        customerId: forms.customerName,
        teamId: teamId.value
      }
      const res = await checkMainContact(payload)
      console.log(res, 'asdfasfasfdsaf')
      exitMainContactFlag.value = res.result?.exitMainContact
      if (exitMainContactFlag.value) {
        ruleFormUsers.isMain = false
      } else {
        ruleFormUsers.isMain = true;
      }
    } catch (e) {
      ruleFormUsers.isMain = false
      console.log(e)
    }
  } else {
    ruleFormUsers.isMain = false
  }
}

const removeEmail = (index) => {
  removeContactItem('mailContactEmailList', index)
};

const removePhone = (index) => {
  removeContactItem('contactPhoneList', index)
}

const removeText = (index) => {
  removeContactItem('contactWayList', index)
}

const removeContactItem = (flag, index) => {
  ruleFormUsers[flag].splice(index, 1);
}


//复制文本
const copyEmail = async () => {
  await navigator.clipboard.writeText(forms.email);
  ElMessage.success('复制成功');
}


const addEmail = () => addContactItem('mailContactEmailList', 'content');
const addPhone = () => addContactItem('contactPhoneList', 'content');
const addText = () => addContactItem('contactWayList', 'content')

const addContactItem = (listKey, fieldKey = 'email') => {
  const list = ruleFormUsers[listKey];

  // 1️⃣ 判断是否已有空字段
  // const hasEmpty = list.some((item) => item[fieldKey] === '');
  // if (hasEmpty) {
  //   ElMessage.error(i18n.global.t('detail.add.customer'));
  //   return;
  // }

  // 2️⃣ 添加一个新项
  list.push({
    [fieldKey]: '',
    isDefault: 0,
  });

  // 3️⃣ 确保第一个为默认项
  if (list.length > 0) {
    list[0].isDefault = 1;
  }
};


const updateEvent = (index) => {
  ruleFormUsers.mailContactSouvenirList[index].editing = true;
  ruleFormUsers.mailContactSouvenirList[index].showButtons = true;
};

const removeEvent = (index) => {
  ruleFormUsers.mailContactSouvenirList.splice(index, 1);
};

const showButtons = (index) => {
  ruleFormUsers.mailContactSouvenirList[index].showButtons = true;
};

const hideButtons = (index) => {
  // ruleFormUsers.mailContactSouvenirList[index].showButtons = false;
  // ruleFormUsers.mailContactSouvenirList[index].editing = false;

  if (ruleFormUsers.mailContactSouvenirList[index].remark === "") {
    removeEvent(index);
  }
};

// 添加纪念日
const dates = ref([{value: new Date()}]);
// 添加纪念日
const addEvent = () => {
  ruleFormUsers.mailContactSouvenirList.push({
    remark: "",
    souvenirDay: "",
    editing: true,
    showButtons: true,
  });
  dates.value.push({value: new Date()});
};

// 添加联系人表单
const ruleFormRef = ref(null);
const contactMessage = computed(() => store.state.customer.contactMessage);
const childRef = ref(null)

// 保存添加的联系人
async function saveAllDiaDatas() {
  // console.log(forms, ruleFormRef, forms.merge, '数据整合');
  const {email, customerName, contactName, merge} = forms
  // 是否需要开启表单验证

  // 已有联系人 ---获取更新联系人

  // 添加联系人
  // forms.merge true 已有联系人；false 新建联系人

// 保存客户信息
  if (forms.customerName !== 9999) {
    // console.log(forms.merge,'forms.merge')
    // 非新建客户
    // 归档有三种情况
    if (forms.merge === "新建联系人") {
      // 添加新的联系人
      ruleFormRef.value.validate(async (valid, fields) => {
        if (valid) {
          const copObj = JSON.parse(JSON.stringify(ruleFormUsers));
          console.log(copObj, 'copObj')
          const {mailContactSouvenirList, mailContactEmailList, contactPhoneList, contactWayList} = copObj;
          let resMails = mailContactSouvenirList.map((item) => {
            return {
              ...item,
              souvenirDay: item.souvenirDay && dayjs(item.souvenirDay).isValid()
                  ? dayjs(item.souvenirDay).format("YYYY-MM-DD")
                  : null,
            };
          });
          //默认邮箱
          const selectDefault = mailContactEmailList.some(item => item.isDefault === 1) ? mailContactEmailList.filter(_ => _.content !== "") : mailContactEmailList.map((item, index) => {
            if (index === 0) {
              return {isDefault: 1, content: item.content}
            } else {
              return {...item, isDefault: 1, content: item.content}
            }
          }).filter(_ => _.content !== "");
          // 默认处理电话
          const hasDefaultPhone = contactPhoneList.some(item => item.isDefault === 1)
          const selectDefaultPhone = hasDefaultPhone
              ? contactPhoneList.filter(_ => _.content !== "")
              : contactPhoneList
                  .map((item, index) => ({
                    ...item,
                    isDefault: index === 0 ? 1 : 0,
                  }))
                  .filter(_ => _.content !== "")

          // 默认处理新媒体
          const hasDefaultWay = contactWayList.some(item => item.isDefault === 1)
          const selectDefaultWay = hasDefaultWay
              ? contactWayList.filter(_ => _.content !== "")
              : contactWayList
                  .map((item, index) => ({
                    ...item,
                    isDefault: index === 0 ? 1 : 0,
                  }))
                  .filter(_ => _.content !== "")
          delete copObj.birthday;
          // delete copObj.mailContactSouvenirList;
          // delete copObj.mailContactEmailList
          const targetObj = {
            ...copObj,
            birthday:
                (ruleFormUsers.birthday && dayjs(ruleFormUsers.birthday).isValid())
                    ? dayjs(ruleFormUsers.birthday).format("YYYY-MM-DD")
                    : null,
            mailContactSouvenirList: resMails,
            mailContactEmailList: selectDefault,
            contactPhoneList: selectDefaultPhone,
            contactWayList: selectDefaultWay,
            customerId: forms.customerName,
            teamId: teamId.value,
            isMain: ruleFormUsers.isMain ? 1 : 0
          };
          // 添加联系人邮箱
          console.log(targetObj, 'targetObj')
          let res = await addMailCustomerContact(targetObj);
          if (res.code !== 200) {
            ElMessage.error(res.message);
            return;
          }
          ElMessage.success(res.message);
          // console.log('pinkser', res.result)
          const {id} = res.result;

          if (forms.merge === "已有联系人") {
            // 最终的数据
            const endTargetObj = {
              contactId: id,
              customerId: customerName,
              email,
              teamId: teamId.value,
            }
            // console.log(endTargetObj, 'end')
            await store.dispatch("customer/addAttachment", endTargetObj)
          }
          close()
          reGetList()
        } else {
          // console.log("error submit!", fields);
        }
      });
    } else if (forms.merge === "公司邮箱") {
      //   获取客户详情
      await store.dispatch("customer/getQueryById", {
        customerId: customerName,
      });
      const {emailWayList, phoneWayList} = ruleForm.value

      const payload = {
        emails: [...toRaw(emailWayList).map(item => ({
          id: item.id,
          email: item.content,
          isDefault: item.isDefault === 1
        })), {isDefault: false, email: email}],
        phones: [...toRaw(phoneWayList).map(item => ({
          id: item.id,
          phoneNumber: item.content,
          isDefault: item.isDefault === 1
        }))]
      }

      console.log(ruleForm.value, payload, 'detail')
      await store.commit("customer/setForm", payload)
      const customerType = computed(() => store.state.customer.selectTarget);
      await store.dispatch("customer/UpdateActivity", {
        customerType: customerType.value,
        isAlert: false,
        teamId: teamId.value
      });
      ElMessage.success(i18n.global.t('common.archive'));
      close()
      reGetList()
    } else {
      await store.dispatch("customer/getContactDetail", {
        contactId: merge,
        customerId: customerName,
      });
      const res = JSON.parse(JSON.stringify(contactMessage.value?.mailContactEmailList || []))
      let newEmails = [...res, {
        content: forms.email,
        isDefault: res.filter(_ => _.isDefault === 1).length > 0 ? 0 : 1
      }]
      console.log({
        ...contactMessage.value,
        teamId: teamId.value,
        contactId: contactName,
        customerId: customerName,
        mailContactEmailList: newEmails,
      })
      const result = await editMailCustomerContact({
        ...contactMessage.value,
        teamId: teamId.value,
        contactId: contactName,
        customerId: customerName,
        mailContactEmailList: newEmails,
      })
      if (result.code !== 200) {
        ElMessage.error(result.message)
        return
      }
      ElMessage.success(result.message);
      close()
      reGetList()
    }
  } else {
    console.log('resdddd',)
    // return
    childRef.value.ruleFormRef.validate(async (valid) => {
      if (valid) {
        if (isSelectCreateContact.value) {
          //   是否需要联系人校验
          ruleFormRef.value.validate(async (validitem) => {
            if (validitem) {
              //   新建客户
              const {mailContactEmailList} = ruleFormUsers
              const targetMailContactEmailList = toRaw(mailContactEmailList)
              const result = targetMailContactEmailList.map(item => ({...item, isDefault: 1}))
              const mailContactDTOList = [{
                ...ruleFormUsers,
                teamId: teamId.value,
                mailContactEmailList: result,
                flag: true,//区分客户入口还是收件箱入口
                isMain: ruleFormUsers.isMain ? 1 : 0
              }]
              console.log('innerForm1', mailContactDTOList)
              // return
              await store.dispatch("customer/saveActivity", {mailContactDTOList, teamId: teamId.value, isNoJump: true});
              await nextTick()
              close()
              reGetList()
            } else {
              await nextTick(() => {
                // 获取错误节点
                let isError = ruleFormRef.value.$el.getElementsByClassName('is-error')
                isError[0].scrollIntoView({
                  // 滚动到指定节点
                  // 值有start,center,end，nearest，当前显示在视图区域中间
                  block: 'center',
                  // 值有auto、instant,smooth，缓动动画（当前是慢速的）
                  behavior: 'smooth',
                })
              })
            }
          })
        } else {
          //   新建客户
          await nextTick()
          await store.dispatch("customer/saveActivity", {teamId: teamId.value, isNoJump: true});
          close()
          reGetList()
        }
      } else {
        await nextTick(() => {
          // 获取错误节点
          let isError = childRef.value.ruleFormRef.$el.getElementsByClassName('is-error')
          isError[0].scrollIntoView({
            // 滚动到指定节点
            // 值有start,center,end，nearest，当前显示在视图区域中间
            block: 'center',
            // 值有auto、instant,smooth，缓动动画（当前是慢速的）
            behavior: 'smooth',
          })
        })
      }
    })
  }
}

onMounted(async () => {
  await store.dispatch('customer/getAreaNames')
})

// 语言
const lang = computed(() => store.state.system.langLocal)
const selectMore = async (event) => {
  ruleForm.value.zoneAddress = lang.value !== "zh-CN" ? event.countryEn : event.country;
  ruleForm.value.zoneCode = event.zoneCode;
  ruleForm.value.customerIds = event.zoneCode
  ruleForm.value.teamId = teamId.value;

  //   获取 随机生成的 id
  const payload = {teamId: teamId.value, zoneCode: event.zoneCode}
  await store.dispatch("customer/getCustomerCodeApi", payload)
  ruleForm.value.customerCodeDefault = randomCustomerCode.value;
  store.commit("customer/setIsSelected", true)
}


defineExpose({getAllCustomers})

</script>

<style lang="less" scoped>
@import "../../../views/Customer/less/detail.less";

.inners_warning {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.setting_center {
  display: flex;
  justify-content: center;
}

//:deep(.el-table .read_0) {
//  font-weight: 700 !important;
//}

.wrap {
  background-color: rgb(245, 245, 245);
  padding: 16px;
  height: 100%;

  .inbox .bg_w {
    & :deep(.el-select) {
      width: 200px !important;
    }
  }
}

.fx-j-e {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  margin-top: 30px;
}

.pointer {
  cursor: pointer;
}

.inbox {
  background-color: #fff;
  height: 100%;
}

.bg_w {
  padding: 8px;
  display: flex;
  align-items: center;

  .span {
    font-size: 13px;
    color: rgba(0, 0, 0, .65);
  }
}

.input-with-select {
  width: 350px;
  margin-right: 10px;
}

.screen {
  display: flex;
  justify-content: space-between;
  padding: 6px 0;
  background-color: #f5f5f5;

  .el-button + .el-button {
    margin-left: 2px;
  }

  .el-dropdown {
    margin-left: 2px;
  }
}

.current_mail {
  .mail_info {
    display: flex;
    height: 30px;
    align-items: center;
    padding: 0px 20px;
    background: rgb(229, 229, 229);
    cursor: n-resize;

    div {
      flex: 1;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      font-size: 12px;
    }
  }
}

.box_titles {
  position: relative;
  height: max-content;
  font-size: 14px !important;
  font-weight: 500 !important;
  margin-bottom: 15px !important;
}

.inner_card {
  margin: 15px 0px 15px 20px;
  //background: red;
}

.sp_box {
  width: 45% !important;
}

.footer_box {
  display: flex !important;
  justify-content: flex-end !important;
  align-items: center !important;

  .el-button {
    margin: 0px 10px;
  }
}

.box_titles {
  font-size: 16px;
  color: #262626 !important;
  font-weight: 500 !important;
  height: 20px;
  line-height: 15px;
  border-bottom: 1px solid #e8e8e8;
}

.sp_buttons {
  margin-left: 20px;
  position: absolute;
  left: 105%;
}

:deep(.el-form-item__content) {
  flex-wrap: nowrap !important;
}

.wrap :deep(.el-form-item) {
  margin: 20px 0 0;
  margin-bottom: 8px !important;
}

.el-form-item__content > div {
  position: relative;
}

:deep(.el-scrollbar__bar.is-horizontal) {
  height: 0 !important;
}

:deep(.el-scrollbar__wrap) {
  overflow-x: hidden !important;
  padding-right: 10px !important;
}

:deep(.el-input-group__append) {
  padding: 0 20px 0 0;
}

:deep(.el-input-group__append button.el-button) {
  background: #5a9cf8;
  color: white;
  width: 76px;
  border-radius: 0px 4px 4px 0px !important;
}


.screen_btn {
  button:nth-of-type(1) {
    margin-left: 0px !important;
  }

  button {
    margin-left: 2px !important;
  }
}

:deep(.el-empty__image img) {
  width: 54% !important;
}

:deep(.el-empty__description) {
  margin-top: -20px;
}

.scroll_out_box {
  position: relative;
}

.mail_info {
  width: 100%;
  position: absolute;
  z-index: 999;
}

#pageframe {
  padding: 30px 0px 8px 0px;
}

:deep(.el-card__body) {
  padding-bottom: 10px !important;
}

:deep(.el-checkbox__label) {
  font-size: 15px !important;
  font-weight: 500 !important;
  color: black;
}

#Card {
  padding: 0px !important;
}

//:deep(.el-checkbox.el-checkbox--large .el-checkbox__inner) {
//  border-width: 2px !important;
//  border-color: black !important;
//}

:deep(.el-card__header) {
  margin-bottom: 10px;
}

.tops {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  border-bottom: 1px solid #e8e8e8;
  margin-bottom: 10px;

  .span_block {
    width: 4px;
    height: 16px;
    padding-left: 5px;
    border-left: 4px solid #1890ff;
  }

  .inner_text {
    font-size: 14px;
    font-weight: 500;
    color: #000;
  }
}

:deep(.sp_email .el-input__wrapper) {
  background: #f5f7fa !important;
}

:deep(.sp_email .el-select__wrapper) {
  background: #f5f7fa !important;
}

:deep(.el-input) {
  font-size: 13px !important;
}

:deep(.el-select) {
  font-size: 13px !important;
}

.gutter_my_sp_form {
  width: 17.8vw !important;
  margin: 0px 10px;
}

#Card {
  padding-top: 0px !important;
}

:deep(.el-form-item__content) {
  margin-left: 0px !important;
}

.danger_delete_btn_link:nth-of-type(1) {
  margin: 0 4px !important;
}

.gutter_my {
  flex: 1;
  margin: 0px 10px;
}

:deep(.sp_form_item) {
  height: 24px !important;
  margin-bottom: 20px !important;
}

:deep(.el-checkbox__label) {
  font-size: 14px !important;
}

.contact_my {
  width: 25% !important;
}

:deep(.el-tag) {
  max-width: 100px !important;
}

:deep(.el-form-item__error) {
  padding-top: 0px !important;
}

.sp_form_item {
  :deep(.el-form-item__error) {
    padding-top: 4px !important;
  }
}


.vertical-form-item {
  :deep(.el-form-item__content) {
    display: flex;
    flex-direction: column; /* 垂直排列 */
    align-items: flex-start; /* 左对齐 */
  }
}

.demo-ruleForm-ssssss {
  .sp_form_item {
    :deep(.el-form-item__label) {
      line-height: 26px !important;
    }
  }
}

.email-input {
  display: flex;
  align-items: center;
  gap: 5px;
  width: 100%;
}

:deep(.is-guttered) {
  padding-left: 10px !important;
}

:deep(.el-form-item__label) {
  font-weight: normal !important;
  font-size: 13px !important;
  color: #000 !important;
}

:deep(.el-select__placeholder) {
  font-size: 13px !important;
}

.event-input {
  margin-bottom: 0px !important;
}
</style>
